module.exports = __webpack_public_path__ + "img/user-13.005c80e1.jpg";